import { render } from "./AuthView.vue?vue&type=template&id=c4688fca&scoped=true"
import script from "./AuthView.vue?vue&type=script&lang=js"
export * from "./AuthView.vue?vue&type=script&lang=js"

import "./AuthView.vue?vue&type=style&index=0&id=c4688fca&lang=scss&scoped=true"

import exportComponent from "/var/www/kostyum-admin-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4688fca"]])

export default __exports__